"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue = getValue;
exports.getFormat = getFormat;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const QuantityConversion = __importStar(require("../quantity-conversion"));
function getValue(propertyValue, amountFormat, conversionParameters, useMaxDecimalCount) {
    switch (propertyValue.type) {
        case "text": {
            return property_1.PropertyValue.getText(propertyValue);
        }
        case "integer": {
            return property_1.PropertyValue.getInteger(propertyValue).toString();
        }
        case "amount": {
            const amount = property_1.PropertyValue.getAmount(propertyValue);
            const { selectedUnit, selectedDecimalCount } = getFormat(amountFormat, amount);
            const effectiveDecimalCount = useMaxDecimalCount
                ? 16
                : selectedDecimalCount;
            if (selectedUnit.quantity !== amount.unit.quantity &&
                !conversionParameters) {
                return "Missing conversionParameters";
            }
            const maybeConvertedAmount = selectedUnit.quantity !== amount.unit.quantity && conversionParameters
                ? QuantityConversion.convertQuantity(amount, selectedUnit.quantity, conversionParameters)
                : amount;
            const value = uom_1.Amount.valueAs(selectedUnit, maybeConvertedAmount);
            const valueWithCorrectDecimalCount = value.toFixed(effectiveDecimalCount);
            return valueWithCorrectDecimalCount;
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(propertyValue);
            return "Should never reach here";
    }
}
function getFormat(amountFormat, amount) {
    const selectedUnit = amountFormat ? amountFormat.unit : amount.unit;
    const selectedDecimalCount = amountFormat ? amountFormat.decimalCount : 2;
    return {
        selectedUnit: selectedUnit,
        selectedDecimalCount
    };
}
//# sourceMappingURL=value-format.js.map